// extracted by mini-css-extract-plugin
export var centerText = "_7v-8";
export var container = "_7v-0";
export var doughnutContainer = "_7v-7";
export var legend = "_7v-a";
export var legendItemColorDisplay = "_7v-b";
export var legendItemLabel = "_7v-d";
export var legendItemValue = "_7v-c";
export var lg = "_7v-5";
export var maxWidth = "_7v-9";
export var md = "_7v-4";
export var responsive = "_7v-6";
export var sm = "_7v-3";
export var xs = "_7v-2";
export var xxs = "_7v-1";